import React from "react"
import Pic from "./image"

const Related = () => (
  <div className="flex flex-wrap flex-col lg:flex-row">
    <div className="w-full lg:w-1/3 relative">
      <Pic filename="tremblant-group.jpg" />
      <div class="panel-content bg-gray-700 bg-opacity-50">
        <h4>Latest News</h4>
        <a href="/category/news">
          <button class="btn btn-light">Learn More</button>
        </a>
      </div>
    </div>
    <div className="w-full lg:w-1/3 relative">
      <Pic filename="tremblant-lavoie.jpg" />
      <div class="panel-content bg-gray-700 bg-opacity-50">
        <h4>Get Involved</h4>
        <a href="/active-for-life/">
          <button class="btn btn-light">Learn More</button>
        </a>
      </div>
    </div>
    <div className="w-full lg:w-1/3 relative">
      <Pic filename="tremblant-fence.jpg" />
      <div className="panel-content bg-gray-700 bg-opacity-50">
        <h4>Safesport</h4>
        <a href="/safesport">
          <button className="btn btn-light">Learn More</button>
        </a>
      </div>
    </div>
  </div> //End Main DIV
)

export default Related
